import { collection, onSnapshot, query } from "firebase/firestore";
import { useEffect, useMemo, useState } from "react";
import { firestore } from "../firebase";
import { PaymentCountryCluster } from "../types/PaymentCountryCluster";

export function usePaymentCountryClusters(projectId: string | null) {
  const [clusters, setClusters] = useState<PaymentCountryCluster[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!projectId) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const q = query(
      collection(
        firestore,
        "projects",
        projectId,
        "payment-country-clusters",
      ),
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const data = snapshot.docs.map(
          (doc) => doc.data() as PaymentCountryCluster,
        );
        setClusters(data);
        setIsLoading(false);
      },
      (err) => {
        console.error("Failed to load payment country clusters:", err);
        setIsLoading(false);
      },
    );

    return () => unsubscribe();
  }, [projectId]);

  return useMemo(() => ({ clusters, isLoading }), [clusters, isLoading]);
}
